//Lib 
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Extend
import baseFixedRentalService from '@/scripts/fixedRental/baseFixedRentalService';

// Constant
import { ROUTE_URL } from '@/constant/route';
import { SETTINGS_FIXED_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { PERIOD, ELEMENT_LIST_PERIOD, FIXED_RENTAL_STATUS } from "@/constant/fixedRental";

// Component 

export default {

    extends: baseFixedRentalService,

    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    data() {
        return {
            routeUrl: ROUTE_URL,
            listPeriod: ELEMENT_LIST_PERIOD,
            fixedRentalStatus: FIXED_RENTAL_STATUS,

            dataNote: [
                {
                    label: 'Some things to note when rental plan',
                    children: [
                        {
                            label: '• The rental plan period will be charged immediately after you confirm this notice',
                        },
                        {
                            label: '• We suggest that you should rental plan when the device is running',
                        },
                    ]
                },
            ],

            request: {
                period: PERIOD.THREE_HOUR,
                periodUnit: 1,
                totalCost: 0,
                continueRunning: false,
            }
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null
        },
    },

    mounted() {
        if (this.targetImage) {
            this.request.numberMachine = this.targetImage.fixedRentalNumberMachine;
            this.request.continueRunning = this.targetImage.continueRunning;
        }
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.FIXED_RENTAL_RENEWAL_MACHINE);
        },
        //#endregion

        renewal() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    listMachineId: [this.targetImage.id],
                    period: this.request.period,
                    periodUnit: this.request.periodUnit,
                    continueRunning: this.request.continueRunning,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_FIXED_RENTAL_API.FIXED_RENTAL_RENEWAL_MACHINE, data)
                    .then((res) => {
                        switch (res.errorCode) {
                            case FIXED_RENTAL_STATUS.SUCCESS:
                                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                this.closeThisPopup();
                                this.notificationSuccess('Success ... !', `Image <span style="color: #42A5F5;"> #${this.targetImage.id} (${this.targetImage.name})</span> has been successfully renewed</span>`);
                                break;
                            case FIXED_RENTAL_STATUS.MACHINE_SHUDOWN_INPROGRESS:                             
                                EventBus.$emit("updateMachineState", { machineId: this.targetImage.id, targetState: 3 }); //update to off
                                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });   
                                setTimeout(() => {
                                    this.isShowErrorInformation = true;
                                }, 500);
                                this.errorCode = res.errorCode
                                break;
                            case FIXED_RENTAL_STATUS.BALANCE_NOT_ENOUGH:
                            case FIXED_RENTAL_STATUS.MACHINE_NOT_AVAILABLE:
                                setTimeout(() => {
                                    this.isShowErrorInformation = true;
                                }, 500);
                                this.errorCode = res.errorCode
                                break;
                        }
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, "Boot failed ...")
                    });
            }, this.smoothTimeOut);
        }
    },
}